// src/components/shared/Form.js
import styled from 'styled-components';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.theme.spacing(4)};
  background-color: ${(props) => props.theme.colors.surface};
  border-radius: ${(props) => props.theme.borderRadius};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 0 auto;
  color: ${(props) => props.theme.colors.textPrimary};  
  width: 100%;
  @media (max-width: 768px) {
    padding: ${(props) => props.theme.spacing(3)}; /* Reduce padding slightly on mobile */
    max-width: 90%; /* Ensure form width fits mobile screens */
  }
`;

export default Form;
